const state = {
  modelShow: false,
  info: {}
};

const getters = {
  recruit: state => state,
  recruitInfo: state => state.info
};

const mutations = {
  changelanguage(state, language) {
    state.language = language;
    localStorage.setItem("language", language);
  },
  changeRModel(state, data) {
    state.modelShow = data;
  },
  setInfo(state, data) {
    state.info = data;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/recruit.js